"use client";

import type { FC, ReactNode } from "react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { useCalloutBanner } from "contexts/CalloutBannerContext";
import { useDirectStakeInfos } from "contexts/DirectStakeContext";
import { useWalletInfo } from "contexts/WalletInfoContext";
import useGovernance from "hooks/useGovernanceData";

interface BannerSectionProps {
  children: ReactNode;
}

export const BannerSection: FC<BannerSectionProps> = ({ children }) => {
  const { t } = useTranslation();
  const governance = useGovernance();
  const { usersMNDEDirectedStakeVotes } = useDirectStakeInfos();
  const { walletAddress, veMNDEBalance } = useWalletInfo();
  const { showBanner, closeBanner } = useCalloutBanner();

  useEffect(() => {
    if (governance.data?.nfts.length && walletAddress) {
      showBanner(t("callout-banner.new-governance"));
    } else {
      closeBanner();
    }
  }, [
    governance.data?.nfts.length,
    walletAddress,
    showBanner,
    closeBanner,
    t,
    veMNDEBalance,
    usersMNDEDirectedStakeVotes,
  ]);

  return (children as React.ReactElement) ?? null;
};
